/**
 * @file video-popup.js
 */
(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.kodakVideoPopup = {
    attach: function () {
      if($(".popup-youtube").length > 0){
        $(".popup-youtube").magnificPopup({
          type: "iframe",
          gallery: {
            enabled: true,
          },
        });
  
        $(".popup-youtube").each(function () {
          $(this).removeAttr('target').removeAttr('rel').removeAttr('title');
        });
      }
    },
  };
})(jQuery, Drupal, once);
